import { PAYMENT_DELIVERY_SECTIONS } from "@/config/sellerProfile/paymentDeliverySections";
import { STORE_INFO_SECTIONS } from "@/config/sellerProfile/storeInfoSections";
import { STORE_LOCATIONS_SECTIONS } from "@/config/sellerProfile/storeLocationsSections";

// Denominator is this list, not seller_profile.total_slots. A future webshop
// section joins the list with countsTowardCompleteness: true and the fraction grows.
export const PROFILE_COMPLETENESS_SECTIONS = [
    ...STORE_INFO_SECTIONS,
    ...PAYMENT_DELIVERY_SECTIONS,
    ...STORE_LOCATIONS_SECTIONS,
];

export function countsTowardCompleteness(section) {
    return section?.countsTowardCompleteness !== false;
}

export function isGroupComplete(sectionsState, sectionDefs) {
    return sectionDefs
        .filter(countsTowardCompleteness)
        .every((section) => Boolean(sectionsState[section.id]?.isComplete));
}

export function countedCompleteCount(sectionsState, sectionDefs) {
    return sectionDefs.filter(
        (section) => countsTowardCompleteness(section) && sectionsState[section.id]?.isComplete
    ).length;
}

export function sectionFlagsFromApi(sections) {
    if (!sections || typeof sections !== "object") {
        return {};
    }

    return Object.fromEntries(
        Object.entries(sections).map(([id, complete]) => [id, Boolean(complete)])
    );
}

export function sectionFlagsFromGroup(groupState) {
    return Object.fromEntries(
        Object.entries(groupState || {})
            .filter(([, section]) => section && typeof section === "object" && "isComplete" in section)
            .map(([id, section]) => [id, Boolean(section.isComplete)])
    );
}

export function completenessSummary(sectionFlags, sectionDefs = PROFILE_COMPLETENESS_SECTIONS) {
    const counted = sectionDefs.filter(countsTowardCompleteness);
    const completeCount = counted.filter((section) => Boolean(sectionFlags?.[section.id])).length;
    const total = counted.length;

    return {
        completeCount,
        total,
        percent: total === 0 ? 0 : Math.round((completeCount / total) * 100),
    };
}
